'use strict';

var productTabs = document.querySelector('[data-tabs]');
if (productTabs) {
  setEvents();
}

function setEvents() {
  var btns = productTabs.querySelectorAll('[data-tabs-btn] button');
  btns.forEach(function (btn) {
    return btn.addEventListener('click', function (event) {
      return toggleTab(event);
    });
  });
}

function toggleTab(_ref) {
  var currentTarget = _ref.currentTarget;

  var index = currentTarget.dataset.index;
  toggleBtn(currentTarget);
  toggleContent(index);
}

function toggleBtn(btn) {
  var activeTab = productTabs.querySelector('button.active');
  activeTab.classList.remove('active');
  btn.classList.add('active');
}

function toggleContent(index) {
  var activeContent = productTabs.querySelector('[data-tabs-content] div.active');
  activeContent.classList.remove('active');

  var contentToActivate = productTabs.querySelector('[data-tabs-content] div[data-index="' + index + '"]');
  contentToActivate.classList.add('active');
}